import { render, staticRenderFns } from "./acceso_sin_codigo.vue?vue&type=template&id=307a53db&scoped=true"
import script from "./acceso_sin_codigo.vue?vue&type=script&lang=js"
export * from "./acceso_sin_codigo.vue?vue&type=script&lang=js"
import style0 from "./acceso_sin_codigo.vue?vue&type=style&index=0&id=307a53db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307a53db",
  null
  
)

export default component.exports